<template>
  <div class="shopVideo">
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
          class="video-con"
          v-model="loading"
          :finished="finished"
          :error.sync="isError"
          error-text="请求失败，点击重新加载"
          finished-text="没有更多了"
          @load="getList"
      >
        <div class="item" v-for="(item, i) in list" :key="i" @click="goShopVideoDetail(item, i)">
          <img class="cover" :src="checkQiNiuUrl(item.coverPhotoUrl)" alt="">
          <div class="cover-top">
            <div class="room">直播回放</div>
            <div v-if="item.liveBroadcastType==='VIDEO'" class="live-type live-type-video">视频</div>
            <div v-if="item.liveBroadcastType==='AUDIO'" class="live-type live-type-audio">音频</div>
            <div class="duration-con">
              <img class="icon" :src="checkQiNiuUrl('5gshop/live/zhujiangren.png')" alt="">
              <span class="text">{{ item.nickname }}</span>
            </div>
            <div class="time-con">
              <span class="text">{{ item.gmtCreate | dataFormat('yyyy-MM-dd hh:mm:ss') }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <get-shop-info :title="'直播回放列表'"/>
  </div>
</template>

<script>
import { getVideoFilesList } from '@/api/im/index'
import GetShopInfo from '@/components/getShopInfo'
export default {
  components: {
    GetShopInfo,
  },
  data() {
    return {
      list: [],
      refreshLoading: false,
      loading: false,
      finished: false,
      isError: false,
      page: 1,
      size: 10,
    }
  },
  created() {
    if(this.$route.query.shopId){
      // this.getList()
    }
  },
  methods: {
    onRefresh(){
      this.finished = true;
      this.page = 1;
      window.setTimeout(()=>{
        this.finished = false;
        this.list = [];
        this.refreshLoading = false;
        window.scrollTo(0, 0);
      },100)
    },
    // 获取视频列表
    getList(){
      let req = {
        videoFileSearchEnum: 'PUBLIC',// PUBLIC, OWNER
        belongToType: 'SHOP',
        belongToAccount: this.$route.query.shopId,
        type: 'INTERACT',
        stat: 1,
        page: this.page,
        size: this.size,
      }
      getVideoFilesList(req).then(res=>{
        if(res.code===200){
          let arr = res.data.items || []
          if(res.data.totalCount===0){
            this.loading = false;
            this.finished = true;
          }
          // 如果是第一页需手动制空列表
          if (this.page === 1){
            this.list = [];
          }
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr)
          this.loading = false

          if(res.data.totalPages===this.page){ // 到达最大页
            this.finished = true;
          }
          this.page++
        }else {
          this.loading = false;
          this.finished = true;
          this.$toast(res.message)
        }
      }).catch(() => {
        this.isError = true;
      })
    },
    // 跳转至视频详情
    goShopVideoDetail(item, i){
      this.$router.push({name: 'shopLiveReplayDetail', query: {shopId: this.$route.query.shopId, vid: item.vid}})
    },
  }
}
</script>

<style lang="less" scoped>
.shopVideo{
  background-color: #f4f4f4;min-height: 93vh;
  .video-con{
    display: flex;flex-wrap: wrap;
    justify-content: flex-start;
    padding: 10px 0 10px 10px;
    .item{
      position: relative;width: 171px;height: 171px;border-radius: 10px;
      overflow: hidden;margin-right: 10px;margin-bottom: 10px;
      .cover{
        width: 100%;height: 171px;object-fit: cover;
      }
      .cover-top{
        position: absolute;z-index: 1;top: 0;left: 0;right: 0;bottom: 0;
        color: #fff;
        .room{
          font-size: 12px;height: 20px;padding: 0 9px;
          border-top-right-radius: 10px;border-bottom-right-radius: 10px;
          display: flex;justify-content: center;align-items: center;
          background-image: linear-gradient(90deg, #1585F3, #00C3F8);
          position: absolute;top: 5px;left: 0;
        }
        .live-type{
          font-size: 10px;width: 35px;height: 20px;border-radius: 10px;
          display: flex;justify-content: center;align-items: center;
          position: absolute;top: 5px;right: 5px;
          &.live-type-video{
            background-image: linear-gradient(90deg, #FB7070, #FEA045);
          }
          &.live-type-audio{
            background-image: linear-gradient(90deg, #8A81FF, #EA63CC);
          }
        }
        .duration-con{
          font-size: 12px;position: absolute;bottom: 22.5px;left: 7.5px;
          display: flex;
          .icon{
            width: 8.5px;height: 12px;margin-right: 4.5px;display: block;
          }
          .span{
            flex: 1;
          }
        }
        .time-con{
          font-size: 12px;position: absolute;bottom: 6.5px;left: 7px;
          display: flex;
          .icon{
            width: 9px;height: 11px;margin-right: 4px;display: block;
          }
          .span{
            flex: 1;
          }
        }
      }
    }
  }
  /deep/ .van-list__finished-text{
    width: 100%;
  }
}

</style>